export enum ClearableCache {
  SaleMethodBranch = "SaleMethodBranch",
  PaymentMethodLookUp = "PaymentMethodLookUp",
  Branches = "Branches",
  SalePriceType = "SalePriceType",
  GetDefalultCustomer = "GetDefalultCustomer",
  PrintPolicy = "PrintPolicy",
  PrintTemplate = "PrintTemplate",
  PrintTemplateLookup = "PrintTemplateLookup",
  ItemCategoryLookup = "ItemCategoryLookup",
  FormSetting = "FormSetting",
  ComputerName = "ComputerName",
  DashboardSetting = "DashboardSetting",
  LocalSetting = "LocalSetting",
}
